// extracted by mini-css-extract-plugin
var _1 = "rkK6B";
var _2 = "sPUh4";
export { _1 as "backButton", _2 as "icon" }
